import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'state/store';
import { USPSState } from 'state/usps/usps.reducers';

export const uspsStateSelector = (state: RootState): USPSState => state.uspsReducer;

export const isBusySelector = createSelector(uspsStateSelector, (uspsReducer) => uspsReducer.isBusy);
export const verifiedAddressSelector = createSelector(uspsStateSelector, (uspsReducer) => uspsReducer.verifiedAddress);
